import React, { useState, useEffect } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { DatePicker,message } from "antd";
import Select from "react-select";
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Country, State } from "country-state-city";
import { useLocation } from "react-router-dom";
import moment from 'moment';
import { updatehospital } from "../../services/admin/hospital/hospital";
import dayjs from 'dayjs';



import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { useMessageApi } from "../../services/message api/MessageProvider";

const EditHospital = () => {

  const location = useLocation();
const { hospital } = location.state || {}; // fallback in case state is missing

console.log("hospital", hospital)

  const  id  = hospital?.id;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
   const [isClicked, setIsClicked] = useState(false);
      const [selectedOption, setSelectedOption] = useState(null);
      const [country, setCountry] = useState();
      const [statevalue, setStateValue] = useState();
    
      useEffect(() => {
        const states = State.getStatesOfCountry("IN"); 
        const formattedStates = states?.map((state) => ({
          label: state.name,
          value: state.name,
        }));
        const options = Country.getAllCountries()?.map((country) => ({
          label: country.name,
          value: country.name,
        }));
        setCountry(options);
        setStateValue(formattedStates);
      }, []); 

  const [formData, setFormData] = useState({
    hospitalName: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobile: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pinCode: "",
    status: "active",
    startDate: "",
    endDate: "",
    noOfDays: "",
    receptionistCount: "",
    pharmacyCount: "",
    bill_no_sequence_prefix: "",
    bill_no_sequence_start: "",
    bill_receipt_no_start: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
  if (hospital) {
    setFormData({
      hospitalName: hospital.Name || "",
      email: hospital.Email || "",
      password: "", // keep it empty or handle securely
      confirmPassword: "", // keep it empty or handle securely
      mobile: hospital.mobile || "",
      address: hospital.address || "",
      city: hospital.city || "",
      state: hospital.state || "",
      country: hospital.country || "",
      pinCode: hospital.pincode || "",
      status: "active",
      startDate: hospital.start_date || "",
      endDate: hospital.end_date || "",
      noOfDays: hospital.no_of_days?.toString() || "",
      receptionistCount: hospital.how_many_create_receptionist?.toString() || "",
      pharmacyCount: hospital.how_many_create_pharmacy?.toString() || "",
       // 👇 PREFILL BILLING
      bill_no_sequence_prefix: hospital.bill_no_sequence_prefix || "",
      bill_no_sequence_start: hospital.bill_no_sequence_start?.toString() || "",
      bill_receipt_no_start: hospital.bill_receipt_no_start?.toString() || ""
    });
  }
  console.log("hospital", hospital)
}, []);




  const validateForm = () => {
  let newErrors = {};

  if (!formData.hospitalName.trim()) {
    newErrors.hospitalName = "Hospital Name is required";
  }
  if(!formData.email.trim()) {
    newErrors.email = "Email is required";      
  }
  if (!formData.mobile.trim()) {  
    newErrors.mobile = "Mobile is required";
  }
  if(!formData.startDate.trim()) {
    newErrors.startDate = "Start Date is required";
  }
  if (!formData.endDate.trim()) {
    newErrors.endDate = "End Date is required";
  }
  // Only validate password if user entered something
  // if (formData.password) {
  //   if (formData.password !== formData.confirmPassword) {
  //     newErrors.confirmPassword = "Passwords do not match";
  //   }
  // }
  if (!formData.startDate) {
    newErrors.startDate = "Start Date is required";
  }
  if (!formData.endDate) {
    newErrors.endDate = "End Date is required";
  } else if (new Date(formData.startDate) > new Date(formData.endDate)) {
    newErrors.endDate = "End Date must be after Start Date";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

  const calculateDays = (start, end) => {
    if (!start || !end) return "";
    
    const startDate = new Date(start);
    const endDate = new Date(end);
    const timeDiff = endDate - startDate;
    const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) + 1;
    
    return daysDiff > 0 ? daysDiff.toString() : "";
  };

  const handleChange = (eventOrValue, fieldName) => {
    setFormData((prevData) => {
      let newData = { ...prevData };

      if (eventOrValue && eventOrValue.target) {
        const { name, value, type, checked } = eventOrValue.target;
        if (name) {
          newData[name] = type === 'checkbox' ? checked : value;
        }
      }
      else if (fieldName && (fieldName === "startDate" || fieldName === "endDate")) {
        const dateValue = eventOrValue ? eventOrValue.toISOString().split("T")[0] : "";
        newData[fieldName] = dateValue;
        
        if ((fieldName === "startDate" && newData.endDate) || 
            (fieldName === "endDate" && newData.startDate)) {
          newData.noOfDays = calculateDays(newData.startDate, newData.endDate);
        } else {
          newData.noOfDays = "";
        }
      }
      else if (fieldName) {
        newData[fieldName] = eventOrValue || "";
      }
      else if (eventOrValue && typeof eventOrValue === "object" && "value" in eventOrValue) {
        newData[fieldName] = eventOrValue.value;
      }

      return newData;
    });
  };

   message.config({
        top: 100, // distance from top
        duration: 3,
        placement: 'topRight', // <-- key part for right side
      });
const messageApi = useMessageApi();

  const handleSubmit = async (e) => {
  e.preventDefault();
    console.log("formData", formData); 
  if (validateForm()) {
    setIsClicked(true); // Optional: show loading or disable button

    const payload = {
      name: formData.hospitalName,
      email: formData.email,
      mobile: formData.mobile,
      address: formData.address,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      pincode: formData.pinCode,
      start_date: formData.startDate,
      end_date: formData.endDate,
      no_of_days: formData.noOfDays,
      how_many_create_receptionist: formData.receptionistCount,
      how_many_create_pharmacy: formData.pharmacyCount,
      status: formData.status,
      bill_no_sequence_prefix: formData.bill_no_sequence_prefix,
      bill_no_sequence_start: formData.bill_no_sequence_start,
      bill_receipt_no_start: formData.bill_receipt_no_start,
    };

    try {
      const result = await updatehospital(id, payload);
      if (result.success) {
        console.log("Hospital updated successfully");
       console.log("payload", payload);
        navigate("/hospitallist"); // change to your actual route
      } else {
        console.error("Update failed:", result.error);

        Object.entries(result?.error).forEach(([field, messages]) => {
              messages.forEach((msg) => {
                messageApi.open({
                  type: 'error',
                  content: `${field}: ${msg}`,
                  style: {
                    maxWidth: '300px',
                    minWidth: '300px',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    marginLeft: 'auto', // aligns to right in combination with topRight
                    marginRight: '0',
                  },
                });
              });
            });

        // Optionally show an error message to the user
      }
    } catch (error) {
      console.error("Error updating hospital:", error.message);
    } finally {
      setIsClicked(false);
    }
  }
  else {
  console.log("Validation failed:", errors);

  
}
};


  

  return (
    <div>
      <Header />
      <Sidebar activeClassName="hospital" />
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/hospitallist">Hospitals</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">Edit Hospital</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Hospital Details</h4>
                        </div>
                      </div>
                      <div className="col-12 col-md-12">
                        <div className="form-group local-forms">
                          <label>
                            Hospital Name{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            name="hospitalName"
                            type="text"
                            placeholder="Enter Hospital Name"
                            value={formData.hospitalName}
                            onChange={handleChange}
                          />
                          {errors.hospitalName && (
                            <p style={{ color: "red" }}>
                              {errors.hospitalName}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group local-forms">
                          <label>
                            Email<span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            name="email"
                            type="email"
                            placeholder="admin@medalluvpharma.com"
                            value={formData.email}
                            onChange={handleChange}
                          />
                          {errors.email && (
                            <p style={{ color: "red" }}>{errors.email}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group local-forms">
                          <label>
                            Mobile<span className="login-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            name="mobile"
                            type="text"
                            placeholder="Enter Mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                          />
                          {errors.mobile && (
                            <p style={{ color: "red" }}>{errors.mobile}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group local-forms">
                          <label>Password</label>
                          <input
                            className="form-control"
                            name="password"
                            type="password"
                            placeholder="Leave blank to keep current password"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group local-forms">
                          <label>Confirm Password</label>
                          <input
                            className="form-control"
                            name="confirmPassword"
                            type="password"
                            placeholder="Confirm new password"
                            onChange={handleChange}
                          />
                          {errors.confirmPassword && (
                            <p style={{ color: "red" }}>
                              {errors.confirmPassword}
                            </p>
                          )}
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-group local-forms">
                          <label>Address</label>
                          <input
                            className="form-control"
                            name="address"
                            type="text"
                            placeholder="Enter Address"
                            value={formData.address}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* City Select */}
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>City</label>
                          <input
                            className="form-control"
                            name="city"
                            type="text"
                            value={formData.city}
                            placeholder=""
                            onChange={handleChange}
                          />
                          {errors.city && (
                            <p style={{ color: "red" }}>{errors.city}</p>
                          )}
                        </div>
                      </div>

                      {/* State Select */}
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>State</label>
                          <Select
                            menuPosition={"fixed"}
                            name="state"
                            value={
                              statevalue?.find(
                                (option) => option.value === formData.state,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange(selectedOption?.label, "state")
                            }
                            options={statevalue}
                            placeholder="Select State"
                            menuPortalTarget={document.body}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused
                                  ? "none"
                                  : "2px solid rgba(46, 55, 164, 0.1);",
                                boxShadow: state.isFocused
                                  ? "0 0 0 1px #2e37a4"
                                  : "none",
                                "&:hover": {
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1)",
                                },
                                borderRadius: "10px",
                                fontSize: "14px",
                                minHeight: "45px",
                              }),
                              dropdownIndicator: (base, state) => ({
                                ...base,
                                transform: state.selectProps.menuIsOpen
                                  ? "rotate(-180deg)"
                                  : "rotate(0)",
                                transition: "250ms",
                                width: "35px",
                                height: "35px",
                              }),
                            }}
                          />
                          {errors.state && (
                            <p style={{ color: "red" }}>{errors.state}</p>
                          )}
                        </div>
                      </div>

                      {/* Country Select */}
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>Country</label>
                          <Select
                            menuPosition={"fixed"}
                            name="country"
                            value={
                              country?.find(
                                (option) => option.value === formData.country,
                              ) || null
                            }
                            onChange={(selectedOption) =>
                              handleChange(selectedOption?.label, "country")
                            }
                            options={country}
                            placeholder="Select Country"
                            menuPortalTarget={document.body}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderColor: state.isFocused
                                  ? "none"
                                  : "2px solid rgba(46, 55, 164, 0.1);",
                                boxShadow: state.isFocused
                                  ? "0 0 0 1px #2e37a4"
                                  : "none",
                                "&:hover": {
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1)",
                                },
                                borderRadius: "10px",
                                fontSize: "14px",
                                minHeight: "45px",
                              }),
                              dropdownIndicator: (base, state) => ({
                                ...base,
                                transform: state.selectProps.menuIsOpen
                                  ? "rotate(-180deg)"
                                  : "rotate(0)",
                                transition: "250ms",
                                width: "35px",
                                height: "35px",
                              }),
                            }}
                          />
                          {errors.country && (
                            <p style={{ color: "red" }}>{errors.country}</p>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="form-group local-forms">
                          <label>Pin Code</label>
                          <input
                            className="form-control"
                            name="pinCode"
                            type="text"
                            placeholder="Enter Pin Code"
                            value={formData.pinCode}
                            onChange={handleChange}
                          />
                          {errors.pinCode && (
                            <p style={{ color: "red" }}>{errors.pinCode}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 col-xl-6">
                        <div className="form-group select-gender">
                          <label className="gen-label">Status</label>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                name="status"
                                onChange={handleChange}
                                value="active"
                                checked={formData.status === "active"}
                                className="form-check-input"
                              />
                              Active
                            </label>
                          </div>
                          <div className="form-check-inline">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                onChange={handleChange}
                                value="inactive"
                                name="status"
                                checked={formData.status === "inactive"}
                                className="form-check-input"
                              />
                              Inactive
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms cal-icon">
                          <label>
                            Start Date <span className="login-danger">*</span>
                          </label>
                          <DatePicker
                            className="form-control datetimepicker"
                            value={
                              formData.startDate
                                ? dayjs(formData.startDate, "YYYY-MM-DD", true) // strict parse
                                : null
                            }
                            onChange={(
                              date /* dayjs */,
                              dateString /* 'YYYY-MM-DD' */,
                            ) =>
                              setFormData((prev) => ({
                                ...prev,
                                startDate: dateString,
                                noOfDays: prev.endDate
                                  ? calculateDays(dateString, prev.endDate)
                                  : "",
                              }))
                            }
                            format="YYYY-MM-DD"
                            placeholder="Enter Start Date"
                          />

                          {errors.startDate && (
                            <p style={{ color: "red" }}>{errors.startDate}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms cal-icon">
                          <label>
                            End Date <span className="login-danger">*</span>
                          </label>

                          <DatePicker
                            className="form-control datetimepicker"
                            value={
                              formData.endDate
                                ? dayjs(formData.endDate, "YYYY-MM-DD", true) // strict parse
                                : null
                            }
                            onChange={(
                              date /* dayjs */,
                              dateString /* 'YYYY-MM-DD' */,
                            ) =>
                              setFormData((prev) => ({
                                ...prev,
                                endDate: dateString,
                                noOfDays: prev.endDate
                                  ? calculateDays(dateString, prev.endDate)
                                  : "",
                              }))
                            }
                            format="YYYY-MM-DD"
                            placeholder="Enter End Date"
                          />

                          {errors.endDate && (
                            <p style={{ color: "red" }}>{errors.endDate}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>No of Days</label>
                          <input
                            className="form-control"
                            name="noOfDays"
                            type="text"
                            placeholder="No of Days (auto-calculated)"
                            value={formData.noOfDays || ""}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>Bill No Prefix</label>
                          <input
                            className="form-control"
                            name="bill_no_sequence_prefix"
                            type="text"
                            value={formData.bill_no_sequence_prefix}
                            onChange={handleChange}
                            placeholder="e.g. SH1"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>Bill No Start</label>
                          <input
                            className="form-control"
                            name="bill_no_sequence_start"
                            type="number"
                            value={formData.bill_no_sequence_start}
                            onChange={handleChange}
                            placeholder="e.g. 1001"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-4">
                        <div className="form-group local-forms">
                          <label>Bill Receipt Start</label>
                          <input
                            className="form-control"
                            name="bill_receipt_no_start"
                            type="number"
                            value={formData.bill_receipt_no_start}
                            onChange={handleChange}
                            placeholder="e.g. 101"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="form-group local-forms">
                          <label>How Many Create Receptionist</label>
                          <input
                            className="form-control"
                            name="receptionistCount"
                            type="text"
                            placeholder="How Many Create Receptionist"
                            value={formData.receptionistCount}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group local-forms">
                          <label>How Many Create Pharmacy</label>
                          <input
                            className="form-control"
                            name="pharmacyCount"
                            type="text"
                            placeholder="How Many Create Pharmacy"
                            value={formData.pharmacyCount}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form me-2"
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary cancel-form"
                            onClick={() => navigate("/hospitallist")}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditHospital;